import config from 'shared/config/config';

export default {
    modalOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5))'
    },
    modal: {
        position: 'relative',
        zIndex: 1,
        width: '100%',
        maxWidth: '25rem',
        margin: '0 auto',
        background: config.pwa_default_bg_color,
        marginTop: '10vh',
        padding: '1.5rem',
        borderRadius: '5px',
        boxShadow: '2px 2px 5px 5px rgba(0,0, 0, 0.3)',
        border: config.pwa_default_font_color + " !important",
        color: config.pwa_default_font_color + " !important"
    },
    modalCloseIcon: {
        position: 'absolute',
        top: 0,
        right: 0,
        margin: '5px',
        opacity: 0.3,
        cursor: 'pointer',
        '&:hover': {
            opacity: 0.5
        }
    },
    modalHeader: {
        fontFamily: config.main_font + ' !important',
        fontSize: '1.3rem',
        fontWeight: 700,
        textAlign: 'left',
        padding: 0,
        marginTop: '0.5rem',
        marginBottom: '0.5rem',
        color: config.pwa_default_font_color + ' !important'
    },
    modalContent: {
        color: config.pwa_default_font_color + ' !important',
        fontFamily: config.sub_font + ' !important',
    },
    modalStage: {
        width: '22rem',
        height: '100%',
        overflow: 'hidden'
    },
    modalSlider: {
        width: '66rem',
        height: '100%',
        marginLeft: 0,
        transition: 'margin 0.2s ease-out'
    },
    modalSlide: {
        display: 'inline',
        float: 'left',
        height: '100%',
        width: '22rem'
    },
    modalText: {
        fontSize: '1.1rem',
        margin: '1rem 0 2rem',
        fontFamily: config.sub_font,
        color: config.pwa_default_font_color + ' !important',
    },
    modalButtons: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center'
    },
    modalButtonsVertical: {
    },
    modalButton: {
        width: '50%',
        textAlign: 'center',
        margin: '0.3rem',
        padding: '0.5rem 1.3rem',
        fontWeight: 600,
        background: 'linear-gradient(#4ea4c3, #007aa1)',
        borderRadius: '3px',
        border: 'none',
        color: '#fff',
        fontSize: config.root_font_size
    },
    modalButtonWhite: {
        width: '50%',
        textAlign: 'center',
        margin: '0.3rem',
        padding: '0.5rem 1.3rem',
        fontWeight: 600,
        background: 'linear-gradient(#ffffff, #ececec)',
        border: '1px solid #dcdcdc',
        boxShadow: '0 0 2px #dcdcdc',
        color: '#2b8eb0',
        fontSize: config.root_font_size
    },
    modalButtonVertical: {
        width: '100%',
        textAlign: 'center',
        margin: '0.6rem 0',
        padding: '0.8rem 1.3rem',
        fontWeight: 600,
        background: 'linear-gradient(#4ea4c3, #007aa1)',
        borderRadius: '3px',
        border: 'none',
        color: '#fff',
        fontSize: config.root_font_size
    },
    modalButtonVerticalWhite: {
        width: '100%',
        textAlign: 'center',
        margin: '0.6rem 0',
        padding: '0.8rem 1.3rem',
        fontWeight: 600,
        background: 'linear-gradient(#ffffff, #ececec)',
        border: '1px solid #dcdcdc',
        boxShadow: '0 0 2px #dcdcdc',
        color: '#2b8eb0',
        fontSize: config.root_font_size
    }
};
